export default "__VITE_ASSET__d6d58af0__"